import { DocumentDirection, TransportFieldOwner, TransportFieldType } from 'src/app/partnerportal/models/partner-onboarding';

export class FormTransportField {
    Name: string;
    Value: unknown;
    Configuration: unknown;
    Presentation: string;
    Type: TransportFieldType;
    FilledBy: TransportFieldOwner;
    DocumentDirection: DocumentDirection;
    ConversationId: string;

    constructor(source?: Partial<FormTransportField>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class OnboardingDropdownConfiguration {
    PossibleValues: string[];

    constructor(source?: Partial<OnboardingDropdownConfiguration>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}
